import module from 'empresa/module.js'

export const schema = {
  id_moneda: 'number',
  id_sucursal: 'number',
}

export default class EmpresaCuentaInformacionService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, idCuenta) {
    return this.$http.get('/api/empresa/cuenta/informacion', {
      params: {
        empresa_id: empresaId,
        id_cuenta: idCuenta,
      },
      schema,
    })
  }

  put (empresaId, idCuenta, data) {
    return this.$http.put('/api/empresa/cuenta/informacion', data, {
      params: {
        empresa_id: empresaId,
        id_cuenta: idCuenta,
      },
      schema,
    })
  }
}

module.service('EmpresaCuentaInformacion', EmpresaCuentaInformacionService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Cuenta/Informacion.js